<template>
  <div class="in-user-panel">
    <PagesPath :pathTitle="'حساب کاربری'" :pathTitle1="'حساب کاربری'" :pathTo1="'/user-panel'"></PagesPath>
    <div id="mainPanel" class="panel-main-grid py-4 container">
      <section class="panel-side p-3 bg-white box-shaddow20 fontsize-small border-r-10">
        <div class="d-flex justify-content-center mt-4">
          <b-skeleton v-if="status || !user" type="avatar"></b-skeleton>
          <div v-else class="user-panel-img ml-3" id="userProfileImage">
            <img
              v-if="user && user.image != null"
              id="profileImage"
              :src="user.image.url"
            />
            <img v-else />
            <div @click="selectFile()" id="eidtProfileImage">
              <i class="fa fa-edit"></i>
            </div>
          </div>
          <input
            id="chooseImage"
            type="file"
            accept="image/*"
            @change="changeProfileImage"
          />
          <div class="d-flex flex-column mt-3">
            <b-skeleton
              class="userHeaderInfoSkeleton"
              v-if="status || !user"
            ></b-skeleton>
            <template v-else>
              <span
                v-if="user && user.full_name != null"
                class="fontsize16 weight-bold text-color-444"
                >{{ user.full_name }}</span
              >
              <span v-else class="fontsize16 weight-bold text-color-444"
                >حساب کاربری</span
              >
            </template>
            <b-skeleton
              class="userHeaderInfoSkeleton"
              v-if="status || !user"
            ></b-skeleton>
            <span v-else class="fontsize15 text-color-666">{{
              user.mobile
            }}</span>
          </div>
        </div>
        <!-- <b-skeleton v-if="status"></b-skeleton>
        <div v-else id="walletOption">
          <div>
            <span id="amountWalletText"> موجودی کیف پول: </span>
            <span id="amountwallet" class="mr-1"
              >{{ user.wallet.balance | price }} تومان</span
            >
          </div>
          <b-button
            v-b-tooltip.left.hover
            title="شارژ کیف پول"
            data-toggle="modal"
            data-target="#depositModal"
            id="despositWallet"
          >
            +
          </b-button>
        </div>
        <b-skeleton v-if="status"></b-skeleton>
        <div v-else class="d-flex mr-4">
          <span class="fontsize-mini"> موجودی هدیه: </span>
          <span class="fontsize-mini mr-1"
            >{{ user.wallet.gift_balance | price }} تومان</span
          >
        </div> -->

        <ul id="userPanelOption" class="py-5">
          <li class="mb-2">
            <button
              @click="changeTab(1)"
              class="w-100 h-100 text-right py-2 px-3"
              :class="{
                'panel-side-item-active': tab === 1,
                'panel-side-item-deactive': tab !== 1,
              }"
            >
              <UserIcon :color="tab === 1 ? '#ffffff' : '#292626'" />
              <span class="font-w-400 font-s-14 text-color-theme-dark pr-2"
                >حساب کاربری</span
              >
            </button>
          </li>
          <li class="mb-2">
            <button
              @click="changeTab(2)"
              class="w-100 h-100 text-right py-2 px-3"
              :class="{
                'panel-side-item-active': tab === 2,
                'panel-side-item-deactive': tab !== 2,
              }"
            >
              <AddressIcon :color="tab === 2 ? '#ffffff' : '#292626'" />
              <span class="font-w-400 font-s-14 text-color-theme-dark pr-2">
                لیست آدرس ها</span
              >
            </button>
          </li>
          <li class="mb-2">
            <button
              @click="changeTab(3)"
              class="w-100 h-100 text-right py-2 px-3"
              :class="{
                'panel-side-item-active': tab === 3,
                'panel-side-item-deactive': tab !== 3,
              }"
            >
              <OrderIcon :color="tab === 3 ? '#ffffff' : '#292626'" />
              <span class="font-w-400 font-s-14 text-color-theme-dark pr-2">
                پیگیری سفارش</span
              >
            </button>
          </li>
          <li class="mb-2">
            <button
              class="w-100 h-100 text-right py-2 px-3"
              @click="changeTab(4)"
              :class="{
                'panel-side-item-active': tab === 4,
                'panel-side-item-deactive': tab !== 4,
              }"
            >
              <FavoritesIcon :color="tab === 4 ? '#ffffff' : '#292626'" />
              <span class="font-w-400 font-s-14 text-color-theme-dark pr-2"
                >لیست علاقه مندی ها</span
              >
            </button>
          </li>
          <li class="mb-2">
            <button
              class="w-100 h-100 text-right py-2 px-3"
              @click="changeTab(5)"
              :class="{
                'panel-side-item-active': tab === 5,
                'panel-side-item-deactive': tab !== 5,
              }"
            >
              <WalletIcon :color="tab === 5 ? '#ffffff' : '#292626'" />
              <span class="font-w-400 font-s-14 text-color-theme-dark pr-2"
                >کیف پول</span
              >
            </button>
          </li>
          <!-- <li class="mb-2">
            <button
              class="w-100 h-100 text-right py-2 px-3"
              @click="changeTab(6)"
              :class="{
                'panel-side-item-active': tab === 6,
                'panel-side-item-deactive': tab !== 6,
              }"
            >
            <
              <span class="font-w-400 font-s-14 text-color-theme-dark pr-2"
                >برداشت از کیف پول</span
              >
            </button>
          </li> -->
          <!-- <li class="mb-2">
            <button
              class="w-100 h-100 text-right py-2 px-3"
              @click="changeTab(7)"
              :class="{
                'panel-side-item-active': tab === 7,
                'panel-side-item-deactive': tab !== 7,
              }"
            >
              <ContactIcon :color="tab === 7 ? '#ffffff' : '#292626'" />
              <span class="font-w-400 font-s-14 text-color-theme-dark pr-2"
                >پاسخ تماس با ما</span
              >
            </button>
          </li> -->
          <!-- <li class="mb-2">
            <button
              class="w-100 h-100 text-right py-2 px-3"
              @click="changeTab(8)"
              :class="{
                'panel-side-item-active': tab === 8,
                'panel-side-item-deactive': tab !== 8,
              }"
            >
              <NotificationsIcon :color="tab === 8 ? '#ffffff' : '#292626'" />
              <span class="font-w-400 font-s-14 text-color-theme-dark pr-2"
                >پیام ها</span
              >
            </button>
          </li> -->
          <!-- <li class="mb-2">
            <button
              class="w-100 h-100 text-right py-2 px-3"
              @click="changeTab(9)"
              :class="{
                'panel-side-item-active': tab === 9,
                'panel-side-item-deactive': tab !== 9,
              }"
            >
              <span class="font-w-400 font-s-14 text-color-theme-dark pr-2"
                >ثبت دیدگاه</span
              >
            </button>
          </li> -->
          <li class="mb-2">
            <button
              @click.prevent="signOut()"
              :class="{ disabled: disabledlLogout }"
              class="w-100 h-100 text-right py-2 px-3 panel-side-item-deactive"
            >
              <LogoutIcon />
              <span class="font-w-400 font-s-14 text-color-theme-dark pr-2">
                خروج از حساب کاربری</span
              >
            </button>
          </li>
        </ul>
      </section>
      <transition name="tab-fade">
        <user-detail v-if="tab === 1" :tab="tab"></user-detail>
        <user-address v-else-if="tab === 2" :tab="tab"></user-address>
        <orders v-else-if="tab == 3" :tab="tab"></orders>
        <Favorite v-else-if="tab == 4" :tab="tab"></Favorite>
        <Wallet v-else-if="tab == 5" :tab="tab" />
        <Withdraw v-else-if="tab == 6" :tab="tab" />
        <answer v-else-if="tab == 7" :tab="tab" />
        <notification v-else-if="tab == 8" :tab="tab" />
        <productPurchased v-else-if="tab == 9" :tab="tab" />
      </transition>
    </div>
    <CropImage id="crop-profile-2" :image="img" />
    <Deposit />
  </div>
</template>

<script>
import PagesPath from "@/parts/Front/components/PagesPath";
import CropImage from "@/parts/Front/components/CropImage";
import UserAddress from "../components/panel/userAddress.vue";
import UserDetail from "../components/panel/userDetail.vue";
import Orders from "../components/panel/orders.vue";
import Favorite from "../components/panel/Favorite.vue";
import productPurchased from "../components/panel/productPurchased.vue";
import answer from "../components/panel/Answer.vue";
import Wallet from "@/parts/Front/components/panel/Wallet.vue";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import Deposit from "@/parts/Front/components/panel/Wallet/DepositWallet.vue";
import { BSkeleton, BButton, VBTooltip } from "bootstrap-vue";
import Withdraw from "../components/panel/Withdraw";
import notification from "../components/panel/Notification.vue";
import AddressIcon from "@/parts/Front/components/Icon/panelIcons/Address.vue";
import ContactIcon from "@/parts/Front/components/Icon/panelIcons/Contact.vue";
import FavoritesIcon from "@/parts/Front/components/Icon/panelIcons/Favorites.vue";
import LogoutIcon from "@/parts/Front/components/Icon/panelIcons/Logout.vue";
import NotificationsIcon from "@/parts/Front/components/Icon/panelIcons/Notifications.vue";
import OrderIcon from "@/parts/Front/components/Icon/panelIcons/Order.vue";
import UserIcon from "@/parts/Front/components/Icon/panelIcons/User.vue";
import WalletIcon from "@/parts/Front/components/Icon/panelIcons/Wallet.vue";
export default {
  name: "UserPanel",
  components: {
    Withdraw,
    PagesPath,
    UserAddress,
    UserDetail,
    Orders,
    Favorite,
    CropImage,
    Wallet,
    Deposit,
    BSkeleton,
    BButton,
    answer,
    notification,
    productPurchased,
    AddressIcon,
    ContactIcon,
    FavoritesIcon,
    LogoutIcon,
    NotificationsIcon,
    OrderIcon,
    UserIcon,
    WalletIcon,
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  created() {},
  mounted() {
    this.$store.commit("front/resetPanelData");
    if (this.$route.query.section != undefined) {
      let section = this.$route.query.section;
      if (section == "orders") {
        this.tab = 3;
      } else if (section == "favorites") {
        this.tab = 4;
      } else if (section == "wallet") {
        this.tab = 5;
      } else if (section == "withdraw") {
        this.tab = 6;
      } else if (section == "answer") {
        this.tab = 7;
      } else {
        this.tab = 1;
      }
    }
  },
  watch: {
    tab() {
      if (window.innerWidth < 768) {
        setTimeout(() => {
          document
            .querySelector(".panel-main-grid > *:nth-child(2)")
            .scrollIntoView({ behavior: "smooth" });
        }, 400);
      }
    },
  },
  data() {
    return {
      tab: 1,
      disabledlLogout: false,
      img: null,
    };
  },
  beforeCreate() {
    this.$store.dispatch("front/getUserDetailFromServer");
  },
  methods: {
    changeTab(number) {
      if (number == 3) {
        this.tab = 3;
        this.$router.push(
          this.$root.makePath("/user-panel", {
            ...this.$route.query,
            section: "orders",
          })
        );
      } else if (number == 4) {
        this.tab = 4;
        this.$router.push(
          this.$root.makePath("/user-panel", {
            ...this.$route.query,
            section: "favorites",
          })
        );
      } else if (number == 5) {
        this.tab = 5;
        this.$router.push(
          this.$root.makePath("/user-panel", {
            ...this.$route.query,
            section: "wallet",
          })
        );
      } else if (number == 6) {
        if (!this.user.card_number) {
          window
            .swal({
              title: "ابتدا شماره کارت خود را در حساب کاربری تان وارد کنید",
              text: "نکته: روند برگشت مبلغ به حساب 24 تا 48 ساعت کاری زمان میبرد!",
              icon: "warning",
              showCancelButton: true,
              showConfirmButton: true,
              closeOnClickOutside: false,
              buttons: ["بازگشت", "ویرایش اطلاعات کاربری"],
            })
            .then((accepted) => {
              if (accepted) {
                document.getElementById("showEditProfileButton").click();
              } else {
                this.$router.push("/user-panel");
              }
            });
        } else if (this.user.card_number) {
          this.tab = 6;
          this.$router.push(
            this.$root.makePath("/user-panel", {
              ...this.$route.query,
              section: "withdraw",
            })
          );
        }
      } else if (number == 7) {
        this.tab = 7;
        this.$router.push(
          this.$root.makePath("/user-panel", {
            ...this.$route.query,
            section: "answer",
          })
        );
      } else if (number == 8) {
        this.tab = 8;
        this.$router.push(
          this.$root.makePath("/user-panel", {
            ...this.$route.query,
            section: "notification",
          })
        );
      } else if (number == 9) {
        this.tab = 9;
        this.$router.push(
          this.$root.makePath("/user-panel", {
            ...this.$route.query,
            section: "product-Purchased",
          })
        );
      } else {
        this.tab = number;
        if (this.$route.query.section != undefined) {
          let query = Object.assign({}, this.$route.query);
          delete query.section;
          if (query.page != undefined) delete query.page;
          if (query.page != undefined) delete query.status;
          this.$router.replace({ query });
        }
      }
    },
    selectFile() {
      document.getElementById("chooseImage").click();
    },
    changeProfileImage(event) {
      var files = event.target.files || event.dataTransfer.files;
      if (!files.length) return;
      else {
        var reader = new FileReader();
        reader.onload = (e) => {
          this.img = e.target.result;
          window.$("#crop-profile-2").modal("show");
          event.target.value = "";
        };

        reader.readAsDataURL(files[0]);
      }
    },
    signOut() {
      window
        .swal({
          title: "آیا میخواهید خارج شوید؟",

          icon: "warning",

          showCancelButton: true,
          showConfirmButton: true,
          dangerMode: true,
          buttons: ["خیر", "بله خارج شو"],
        })
        .then((willDelete) => {
          if (willDelete) {
            this.disabledlLogout = true;
            this.$axios.post("/customer/logout").then((res) => {
              this.disabledlLogout = false;
              // پاک کردن اطلاعات مربوط به کاربر از کوکی و ویو ایکس
              this.$root.deleteCookie("Authorization");
              delete this.$axios.defaults.headers.common["Authorization"];
              this.$store.commit("front/setLoginStatus", false);
              this.$router.push("/");
              this.$root.notify("با موفقیت خارج شدید", "success");
            });
          }
        });
    },
  },
  computed: {
    user() {
      return this.$store.getters["front/getUserDetail"];
    },
    status() {
      return this.$store.getters["front/getUserDetailStatus"];
    },
  },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.1s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.disabled {
  opacity: 0.5;
  pointer-events: none;
}

/* تنظیمات اسکلتون اطلاعات کاربری ساید بار راست */
.userHeaderInfoSkeleton {
  width: 40px;
  margin-right: 10px;
}

.b-skeleton-avatar {
  width: 3.5em;
  height: 3.5em;
  border-radius: 50%;
}

#mainPanel {
  width: 100%;
  overflow: hidden;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.75s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

#userProfileImage {
  position: relative;
}

#userProfileImage:hover #eidtProfileImage {
  display: block;
}

#eidtProfileImage {
  display: none;
  transition: all 0.5s;
  position: absolute;
  right: 0;
  top: 0;
  cursor: pointer;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: #000000ab;
}

#eidtProfileImage i {
  position: relative;
  right: 25px;
  top: 25px;
  color: #ff8500;
}

#profileImage {
  width: 80px;
  height: 80px;
  object-fit: fill;
}

#chooseImage {
  opacity: 0;
  position: fixed;
  z-index: 0;
  pointer-events: none;
}

#walletSvg {
  width: 22px;
  height: 20px;
  margin-left: 5px;
  transform: translateY(-4px);
}

#moneySvg {
  width: 26px;
  height: 26px;
  margin-left: 9px;
  transform: translateY(-4px);
}
#answerSvg {
  width: 26px;
  height: 26px;
  margin-left: 5px;
  transform: translateY(-4px);
}

#despositWallet {
  background: #121314;
  color: white;
  padding: 0 0px;
  border-radius: 50%;
  height: 30px;
  width: 30px;
  font-size: 22px;
  border: none;
}

#amountWalletText {
  font-weight: bolder;
  font-size: smaller;
}

#amountWalletText {
  font-weight: small;
}

#walletOption {
  margin-top: 12px;
  display: flex;
  justify-content: space-evenly;
}

#userPanelOption {
  padding-top: 2rem !important;
}

.in-user-panel >>> .page-item.pagination-page-nav .page-link {
  background: #f5eae7;
  color: #636363;
}

.in-user-panel >>> .page-item.pagination-page-nav.active .page-link {
  background-color: var(--color-theme);
  color: #fff;
}

.tab-fade-enter-active,
.tab-fade-leave-active {
  transition: opacity 0.25s;
}

.tab-fade-enter /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0.1;
}

.tab-fade-leave {
  display: none;
}

.tab-fade-leave-to {
  display: none;
}

.panel-side ul {
  list-style-type: none;
}

.panel-side ul li > button {
  background: none;
}

.panel-side ul li > button.panel-side-item-active {
  background-color: var(--color-theme6);
  border-radius: 9px;
}
.panel-side ul li > button.panel-side-item-active span {
  background-color: var(--color-theme6);
  color: var(--color-white);
  border-radius: 9px;
}
.panel-side ul li > button.panel-side-item-active svg > circle,
.panel-side ul li > button.panel-side-item-active svg > path {
  stroke: var(--color-theme);
}

.panel-side-item-deactive {
  transition: 200ms all;
}

#userPanelOption li:hover .panel-side-item-deactive {
  transform: translateX(-5px);
}

.panel-side .panel-side-item-active svg > g {
  fill: var(--color-theme);
}

.panel-main-grid {
  display: grid;
  grid-template-columns: 1fr 3fr;
  grid-gap: 15px;
}

.user-panel-img {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  overflow: hidden;
  background-color: gray;
  border: 2px solid lightblue;
}

@media screen and (max-width: 991px) {
  .panel-main-grid {
    grid-template-columns: 1fr 1fr;
  }
}

@media screen and (max-width: 767px) {
  .panel-main-grid {
    grid-template-columns: 1fr;
  }
}
</style>
